<template>
  <div style="width: 100%;">
    <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack"></van-nav-bar>
    <div style="width: 100%;height:50px;"></div>
    <div
      style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
      <!-- <div class="text"></div> -->
      <my-text-one :title="teamName + '团队建设'" :textContent="teamName + '团队建设'"></my-text-one>

      <div style="width: 70%">
        <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="0">
            <span slot="label">教学</span>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label">团建</span>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label">荣誉</span>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label">合作</span>
          </el-tab-pane>
          <el-tab-pane name="4">
            <span slot="label">文件</span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="list-view" :style="{ height: screenHeight }">
        <el-row :gutter="10">
          <el-col :span="8" v-for="(item, i) in videoList" :key="i" @click="currentIndex = i"
            v-if="item.type == selectTabName">
            <!-- <div style="width: 100%;" v-if="item.type==4">

            </div> -->
            <!-- <div style="width: 100%;" @click="imagePreview(i)" v-else> -->
            <div style="width: 100%;" @click="imagePreview(i)">
              <van-image width="100%" height="90px" fit="cover" :src="item.imgUrl" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="kuang">
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
    </div>
    <div @touchstart="touchStart()" @touchend="touchEnd()">
      <van-image-preview :closeable="true" v-model="showPreviewImg" :images="previewImages">
      </van-image-preview>

    </div>
    <van-share-sheet v-model="showShare" title="图片操作" :options="shareOptions" @select="onSelectShare" />

  </div>
</template>

<script>
import LivePlayer from "@liveqing/liveplayer";
import MyTextOne from "@/components/MyTextOneMobile.vue";
import { ImagePreview } from 'vant'
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
  name: "ShowPicture",
  components: {
    LivePlayer,
    MyTextOne,
  },
  data() {
    return {
      // 屏幕宽度
      screenWidth: window.screen.width,
      // 屏幕高度
      screenHeight: window.screen.height - 220 + "px",
      // 分屏布局
      playerNum: 0,
      colSpan: 24,
      currentIndex: 0,
      // 视频播放器
      muted: false,
      autoplay: false,
      videoList: [],

      dataForm: {
        key: "",
      },
      pageIndex: 1,
      pageSize: 40,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,

      currentIndex: 0,
      activeName: "0",
      selectTabName: 0,
      selectScale: -1,

      showPreviewImg: false,
      previewImages: [],
      showShare: false,
      shareOptions: [
        // { name: '微信', icon: 'wechat' },
        // { name: '微博', icon: 'weibo' },
        { id: 1, name: '保存图片', icon: require('@/assets/img/baocuntupian.png') },
      ],
    };
  },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
    handleClick(tab, event) {
      this.selectTabName = Number(tab.name);
      console.log(this.selectTabName);
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/app/picture/list"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          key: this.dataForm.key,
        }),
      }).then(({ data }) => {
        console.log(data);
        if (data && data.code === 0) {
          this.videoList = data.page.list;
          this.playerNum = data.page.totalCount;
        } else {
          this.videoList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    longPressHandler() {
      console.log("长按")
    },
    touchEnd() {
      //手指离开
      clearTimeout(this.timer);
    },
    touchStart() {
      //手指触摸
      clearTimeout(this.timer); //再次清空定时器，防止重复注册定时器
      this.timer = setTimeout(() => {
        // let time = '成绩单_' + parseInt(new Date().getTime() / 1000)
        // console.log("长按");
        // this.downloadIamge(this.previewImages[0], time);
        // this.downLoad()
        this.showShare = true
        // this.isImgDownLoad = true
      }, 500);

    },
    onSelectShare(option) {
      console.log(option.id);
      if (option.id === 1) {
        this.downLoadImg()
      }
      this.showShare = false
    },
    downLoadImg() {

      console.log("长按");
      if (!window.plus) {
        return
      }
      var timestamp = (new Date()).valueOf();
      var downLoader = plus.downloader.createDownload(this.previewImages[0], {

        method: 'GET',

        filename: '_downloads/image/diyun_' + timestamp + '.jpg'
      }, function (download, status) {
        console.log(status)

        if (status == 200) {
          var fileName = download.filename;

          /**
           * 保存至本地相册
           */
          console.log(fileName)
          plus.gallery.save(fileName, function () {
            Toast.success('图片保存成功');

          }, function () {
            Toast.fail('保存失败，请重试！');
          });
        } else {
          Toast.fail('保存失败，请重试！');
        }
      });
      downLoader.start();


    },
    imagePreview(i) {
      this.previewImages = [this.videoList[i].imgUrl]
      this.showPreviewImg = true
      // ImagePreview({
      //   images: [
      //     this.videoList[i].imgUrl,
      //   ],
      //   closeable: true,
      // });

    },
    onClickLeftBack() {
      this.$router.back();
    },
  },
  mounted() {
    this.getDataList();
    console.log(this.screenHeight);
  },
  created() { },
};
</script>
<style lang="less" scoped>
.van-nav-bar {
  background-color: #00000000;
}

/* 需要滚动条隐藏的列表 */
.list-view {
  width: 90%;
  // height: 700px;
  margin-top: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
  display: none;
}

.el-card {

  border: none !important;
  border-radius: 5px !important;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  margin-bottom: 5px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

/deep/ .el-tabs__nav {
  // width: 10px;
  //   font-size: 29px;
  // line-height: 55px;
  height: 35px;
}

::v-deep .el-tabs__item.is-active {
  color: skyblue; //选中
  opacity: 1;
}

::v-deep .el-tabs__item:hover {
  color: skyblue; //悬浮
  cursor: pointer;
  opacity: 1;
}

/deep/.el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-size: 10pt !important;
  color: #fff;
  font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
  /* 去掉下划线 */
  position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
  background-color: skyblue;
}

.obstacles-container {
  position: relative;
  width: 100%;
}

/**背景 **/

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.kuang {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));
}

.bubble {
  position: absolute;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: inset 0 0 8px #fff;
  animation: flutter 10s infinite;
  opacity: 0;
}

@keyframes flutter {
  0% {
    transform: translateX(0);
    bottom: -100px;
    opacity: 1;
  }

  50% {
    transform: translateX(100px);
    opacity: 0.5;
  }

  100% {
    transform: translateX(0px);
    bottom: 100%;
    opacity: 0;
  }
}

.bubble:nth-child(1) {
  left: -10%;
  width: 50px;
  height: 50px;
  animation-duration: 9s;
  animation-delay: 0.1s;
}

.bubble:nth-child(2) {
  left: 15%;
  width: 20px;
  height: 20px;
  animation-duration: 6s;
  animation-delay: 1.5s;
}

.bubble:nth-child(3) {
  left: 20%;
  width: 60px;
  height: 60px;
  animation-duration: 10s;
}

.bubble:nth-child(4) {
  left: 30%;
  width: 30px;
  height: 30px;
  animation-duration: 5.5s;
  animation-delay: 1.5s;
}

.bubble:nth-child(5) {
  left: 40%x;
  width: 50px;
  height: 50px;
  animation-duration: 12s;
}

.bubble:nth-child(6) {
  left: 50%;
  width: 20px;
  height: 20px;
  animation-duration: 6s;
  animation-delay: 1s;
}

.bubble:nth-child(7) {
  left: 60%;
  width: 40px;
  height: 40px;
  animation-duration: 8s;
  animation-delay: 1s;
}

.bubble:nth-child(8) {
  left: 65%;
  width: 60px;
  height: 60px;
  animation-duration: 15s;
}

.bubble:nth-child(9) {
  left: 80%;
  width: 55px;
  height: 55px;
  animation-duration: 9s;
  animation-delay: 0.5s;
}

.bubble:nth-child(10) {
  left: 100%;
  width: 40px;
  height: 40px;
  animation-duration: 12s;
}
</style>